<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_viii"></a><em>Sticks and stones may break my bones<br/>but words will never hurt me... is a Great Big Lie!</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter06.vue?f9ba6326